/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SharedFromUser } from './SharedFromUser';
import {
    SharedFromUserFromJSON,
    SharedFromUserFromJSONTyped,
    SharedFromUserToJSON,
    SharedFromUserToJSONTyped,
} from './SharedFromUser';
import type { LoyaltyAccount } from './LoyaltyAccount';
import {
    LoyaltyAccountFromJSON,
    LoyaltyAccountFromJSONTyped,
    LoyaltyAccountToJSON,
    LoyaltyAccountToJSONTyped,
} from './LoyaltyAccount';

/**
 * A loyalty account shared with the requesting user via an active family pool relationship, wrapped with attribution to the owning peer.
 * @export
 * @interface PooledLoyaltyAccount
 */
export interface PooledLoyaltyAccount {
    /**
     * 
     * @type {LoyaltyAccount}
     * @memberof PooledLoyaltyAccount
     */
    loyaltyAccount: LoyaltyAccount;
    /**
     * 
     * @type {SharedFromUser}
     * @memberof PooledLoyaltyAccount
     */
    sharedFromUser: SharedFromUser;
}

/**
 * Check if a given object implements the PooledLoyaltyAccount interface.
 */
export function instanceOfPooledLoyaltyAccount(value: object): value is PooledLoyaltyAccount {
    if (!('loyaltyAccount' in value) || value['loyaltyAccount'] === undefined) return false;
    if (!('sharedFromUser' in value) || value['sharedFromUser'] === undefined) return false;
    return true;
}

export function PooledLoyaltyAccountFromJSON(json: any): PooledLoyaltyAccount {
    return PooledLoyaltyAccountFromJSONTyped(json, false);
}

export function PooledLoyaltyAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): PooledLoyaltyAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'loyaltyAccount': LoyaltyAccountFromJSON(json['loyalty_account']),
        'sharedFromUser': SharedFromUserFromJSON(json['shared_from_user']),
    };
}

export function PooledLoyaltyAccountToJSON(json: any): PooledLoyaltyAccount {
    return PooledLoyaltyAccountToJSONTyped(json, false);
}

export function PooledLoyaltyAccountToJSONTyped(value?: PooledLoyaltyAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loyalty_account': LoyaltyAccountToJSON(value['loyaltyAccount']),
        'shared_from_user': SharedFromUserToJSON(value['sharedFromUser']),
    };
}

